import React from "react";
import { usePost } from "seed/api";
import l from "components/util/l";
import View from "components/util/schema_form/fields/TextImprovement.view";


const TextImprovement = ({
  children,
  disabled,
  flowId,
  improvementPrompt,
  name,
  setFieldValue,
  value,
}) => {
  const [callImproveText, reqImproveText] = usePost("/flows/improve_text", {
    onCompleted: (data) => setFieldValue(name, data.improved_text),
  });

  const onClickImprove = () => {
    callImproveText({
      flow_id: flowId,
      improvement_prompt: l(improvementPrompt),
      text: value,
    });
  };

  if (!improvementPrompt) return children;

  return (
    <View
      disabled={disabled || !flowId || !value}
      isLoading={reqImproveText.loading}
      onClickImprove={onClickImprove}
    >
      {children}
    </View>
  );
};

export default TextImprovement;
